export default __webpack_public_path__ + "static/media/poster.1052f6e9.png";